import { useContext } from 'react'

import { Box, BoxProps } from '@mantine/core'

import { CarouselOrListingBlockContext } from '../context'
import { useSlideInfo } from '../useSlideInfo'
import useStyles from './index.styles'

const CarouselWrapper = ({
  children,
  styles,
  className,
  classNames,
  ...props
}: BoxProps) => {
  const { embla, filteredChild, showFullSlide } = useContext(
    CarouselOrListingBlockContext,
  )
  const { slideInfo } = useSlideInfo(embla, filteredChild.length)
  const { classes, cx } = useStyles(
    { showFullSlide },
    {
      name: 'CarouselOrListingBlock__CarouselWrapper',
      styles,
      classNames,
    },
  )

  return (
    <Box
      className={cx(
        classes.carouselWrapper,
        !showFullSlide
          ? slideInfo.canScrollNext
            ? 'still-slide'
            : 'end-slide'
          : '',
        className,
      )}
      {...props}
    >
      {children}
    </Box>
  )
}

export { CarouselWrapper }
